import { render, staticRenderFns } from "./ManagemantSection.vue?vue&type=template&id=81b41e48&"
import script from "./ManagemantSection.vue?vue&type=script&lang=ts&"
export * from "./ManagemantSection.vue?vue&type=script&lang=ts&"
import style0 from "./ManagemantSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports